import WidgetIframePresentation from 'components/WidgetIframe/WidgetIframePresentation'

export default {
  Presentation: WidgetIframePresentation,
}
